module.exports = __webpack_public_path__ + "img/slide14_vn.80d5ffa9.jpg";